export default __webpack_public_path__ + "static/Cogs-cfc38785673d49adff56097268697a0e.svg";